import styled from '@emotion/styled';
import Icon from '@mdi/react';
import { Variables } from '../variables';

export const DateButton = styled.button<{ disabled?: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    border: ${Variables.Borders.regular};
    background-color: ${Variables.Colors.white};
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
    transition: ${Variables.transition};
    outline: none;
    padding: 0;

    &:hover {
        background-color: ${props => (props.disabled ? Variables.Colors.white : Variables.Colors.n15_24)};
    }

    &:active {
        background-color: ${props => (props.disabled ? Variables.Colors.white : Variables.Colors.n15_48)};
    }

    &:disabled {
        border-color: ${Variables.Colors.nx8};
        background-color: ${Variables.Colors.nx4};
    }
`;

export const DateButtonIcon = styled(Icon)`
    width: 20px;
    height: 20px;
    path {
        fill: ${Variables.Colors.n70};
    }
`;

export const DateButtonText = styled.span`
    font-size: 13px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.Colors.n70};
    line-height: 1;
    user-select: none;
`;

export const PopoverContainer = styled.div`
    overflow: visible;
    max-width: fit-content;

    .rdp {
        --rdp-cell-size: 40px;
        --rdp-accent-color: ${Variables.Colors.b500};
        --rdp-background-color: ${Variables.Colors.b100};
        margin: 0;
    }

    .rdp-months {
        justify-content: center;
    }

    .rdp-month {
        margin: 0 16px 16px 16px;
    }

    .rdp-table {
        border-spacing: 0;
        border-collapse: separate;
    }

    .rdp-head_cell {
        padding: 8px 0;
        font-size: 12px;
        font-weight: ${Variables.FontWeight.semibold};
        color: ${Variables.Colors.n50};
        text-transform: uppercase;
    }

    .rdp-cell {
        padding: 2px;
    }

    .rdp-button {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        font-size: 14px;
        font-weight: 500;
        color: ${Variables.Colors.n70};
        border: none;
        background: none;
        cursor: pointer;

        &:hover:not([disabled]):not(.rdp-day_selected) {
            background-color: ${Variables.Colors.n15_24};
        }

        &:focus-visible {
            outline: 2px solid ${Variables.Colors.b500};
            outline-offset: 2px;
        }
    }

    .rdp-day_today:not(.rdp-day_selected) {
        background-color: ${Variables.Swatches.AlphaMiddleRed50};
        font-weight: ${Variables.FontWeight.semibold};
    }

    .rdp-day_selected {
        background-color: ${Variables.Colors.b500};
        color: ${Variables.Colors.white};
        font-weight: ${Variables.FontWeight.semibold};

        &:hover {
            background-color: ${Variables.Swatches.AlphaMiddleBlue60};
        }
    }

    .rdp-day_outside {
        color: ${Variables.Colors.n30};
    }

    .rdp-day_disabled {
        color: ${Variables.Colors.n30};
        cursor: default;

        &:hover {
            background: none;
        }
    }
`;
